function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { trackEvent } from "/services/bigbrain-service";
import { ENRICHED_FORM_RENDERED } from "constants/bigbrain-event-types";
// Mapping from enriched data fields to form field names
const FORM_FIELDS_BY_ENRICHED_DATA_FIELDS = {
    firstName: [
        "first_name"
    ],
    lastName: [
        "last_name"
    ],
    companyName: [
        "company_name"
    ],
    jobTitle: [
        "job_title"
    ]
};
// Mapping from enriched data fields to hubspot field names
const HUBSPOT_FIELDS_BY_ENRICHED_DATA_FIELDS = {
    firstname: "firstName",
    lastname: "lastName",
    jobtitle: "jobTitle",
    phone: "phoneNumber",
    company: "companyName"
};
// Extracts the IDs from the data and counts them
const extractIdsAndCount = (data)=>{
    // Flatten the rows into a single array and filter out items without an ID
    const idsList = data === null || data === void 0 ? void 0 : data.rows.flatMap((subArray)=>subArray.filter((item)=>item.id).map((item)=>item.id));
    // Return the list of IDs and the count
    return {
        idsList,
        idsLength: idsList.length
    };
};
export const removeEnrichedFieldsFromForm = (enrichedData, formConfig)=>{
    // Create a deep copy of the formConfig
    const formConfigDuplication = _object_spread_props(_object_spread({}, formConfig), {
        rows: formConfig.rows.map((row)=>[
                ...row
            ])
    });
    // Iterate over enrichedData fields
    for(const field in enrichedData){
        if (FORM_FIELDS_BY_ENRICHED_DATA_FIELDS[field] && enrichedData[field] !== null) {
            // Remove corresponding fields from formConfigDuplication rows and filter out empty rows
            formConfigDuplication.rows = formConfigDuplication.rows.map((row)=>row.filter((fieldToRemove)=>!FORM_FIELDS_BY_ENRICHED_DATA_FIELDS[field].includes(fieldToRemove.id))).filter((row)=>row.length > 0);
        }
    }
    const { idsList, idsLength } = extractIdsAndCount(formConfigDuplication);
    trackEvent(ENRICHED_FORM_RENDERED, {
        kind: idsLength,
        info1: idsList
    }); //send also email as info2
    return formConfigDuplication;
};
export const updateFormData = (formData, enrichedData)=>{
    // Create a set of existing formData keys
    const existingKeys = new Set(formData.map((item)=>item.name));
    // Create a new formData array to avoid modifying the original in place
    const updatedFormData = [
        ...formData
    ];
    // Add missing fields from enrichedData to formData
    for (const [formKey, enrichedKey] of Object.entries(HUBSPOT_FIELDS_BY_ENRICHED_DATA_FIELDS)){
        if (!existingKeys.has(formKey) && enrichedKey in enrichedData) {
            const enrichedFieldvalue = enrichedData[enrichedKey];
            if (enrichedFieldvalue) {
                updatedFormData.push({
                    name: formKey,
                    value: enrichedFieldvalue
                });
            }
        }
    }
    return updatedFormData;
};
